import { withStyles } from "@material-ui/core/styles";
import Notification from "./Notification";
import styles from "./styles";

export default withStyles(styles)(Notification);
